import * as tslib_1 from "tslib";
import { getFallbackValueIfNull, updateUserOptions } from 'owa-options-core';
import getWeatherOption from '../data/store/store';
import { getCalendarConfiguration, saveCalendarMailboxConfiguration, updateCalendarMailboxConfiguration, } from 'owa-calendar-configuration';
import initiateWeatherPullTaskOnCalendar from '../data/actions/initiateWeatherPullTaskOnCalendar';
export default function saveWeatherOption() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, calendarConfiguration, newWeatherEnableStatus, newWeatherUnitSelected, partialCalendarMailboxConfiguration;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = getWeatherOption();
                    calendarConfiguration = getCalendarConfiguration();
                    newWeatherEnableStatus = getFallbackValueIfNull(optionState.weatherEnabled, calendarConfiguration.WeatherEnabled);
                    newWeatherUnitSelected = getFallbackValueIfNull(optionState.weatherUnit, calendarConfiguration.WeatherUnit);
                    partialCalendarMailboxConfiguration = {
                        WeatherEnabled: newWeatherEnableStatus,
                        WeatherUnit: newWeatherUnitSelected,
                    };
                    // update the UserOptions so that changes reflect in current session
                    updateUserOptions(partialCalendarMailboxConfiguration);
                    updateCalendarMailboxConfiguration(partialCalendarMailboxConfiguration);
                    /**
                     *  This action has been called to notify calendar
                     *  that save is initiated in settings and run weatherPull task
                     *  in calendar to update weather on calendar surface
                     */
                    initiateWeatherPullTaskOnCalendar();
                    // save the new calendar configuration at server
                    return [4 /*yield*/, saveCalendarMailboxConfiguration(partialCalendarMailboxConfiguration)];
                case 1:
                    // save the new calendar configuration at server
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=saveWeatherOption.js.map